import { useEffect, useSyncExternalStore } from "react";
import { SPACE_POLICY_SEEDS } from "./spacePolicyValues.js";
import { fitPolicy } from "./spacePolicyValues.js";
let snapshot = { status: "idle", baseline: SPACE_POLICY_SEEDS };
let pending;
let readers = 0;
let timer;
const listeners = new Set();
export const getSpacePolicy = () => snapshot.baseline;
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const publish = value => { snapshot = value; listeners.forEach(listener => listener()); };
export async function refreshSpacePolicy() {
  if (pending) return pending;
  if (snapshot.status !== "ok") publish({ status: "loading", baseline: null });
  pending = import("../features/plan/policyClient.js").then(m => m.getEffectiveSpacePolicy())
    .then(data => {
      if (!fitPolicy(data?.baseline)) throw new Error("Space Policy has missing or incoherent guardrails.");
      if (snapshot.status !== "ok" || JSON.stringify(snapshot.baseline) !== JSON.stringify(data.baseline))
        publish({ status: "ok", baseline: data.baseline });
      return data.baseline;
    })
    .catch(error => { publish({ status: "error", baseline: null, error: error.message }); throw error; })
    .finally(() => { pending = null; });
  return pending;
}
export function useSpacePolicy(enabled = true) {
  const value = useSyncExternalStore(subscribe, () => snapshot);
  useEffect(() => {
    if (!enabled) return;
    if (snapshot.status === "idle") refreshSpacePolicy().catch(() => {});
    const refresh = () => refreshSpacePolicy().catch(() => {});
    if (++readers === 1) {
      window.addEventListener("focus", refresh);
      timer = { id: window.setInterval(refresh, 60000), refresh };
    }
    return () => {
      if (--readers === 0 && timer) {
        window.removeEventListener("focus", timer.refresh); window.clearInterval(timer.id); timer = null;
      }
    };
  }, [enabled]);
  return value;
}
